
// import { createOrg } from '@/services'
import {
  fetchQwDatas,
  fetchDdDatas,
  inviteAdmin } from '@/services/organization'
export default {
  namespaced: true,
  state: {
    submitting: false,
    cId: 0,
    qWData: {},
    ddData: {},
    datasReady: false,
    datasReady2: false
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    },
    setCId (state, cid) {
      state.cId = cid
    },
    setQWData (state, obj) {
      state.qWData = obj
      state.datasReady = true
    },
    setDdData (state, obj) {
      state.ddData = obj
      state.datasReady2 = true
    }
  },
  actions: {
    // async getQw ({ commit, state }, param = {}) {
    //   // const { keywords } = param
    //   const res = await fetchApi(
    //     axios => axios.get('/user/organize/installqw', { params: param }),
    //     async (payload = {}) => {
    //       commit('setQWData', payload)
    //     }
    //   )
    //   return res
    // },
    // 邮箱重复验证
    async getQw ({ commit }) {
      commit('setSubmitting', true)
      const chain = await fetchQwDatas()
        .onSuccess(raw => {
          commit('setQWData', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async getDd ({ commit }) {
      commit('setSubmitting', true)
      const chain = await fetchDdDatas()
        .onSuccess(raw => {
          commit('setDdData', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    // 邀请人员表单提交
    async ajaxSave ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await inviteAdmin()
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    }
  }
}
